import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {CookieService} from 'ngx-cookie';

declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  reportUrl: string = DDP_ENV.reportUrl;
  constructor(private _http: Http, private cookieService: CookieService) { }

  generateReport(reportDetails) {
    return this._http.post(this.reportUrl, reportDetails, this.buildHeaders());
  }

  getReportsByClientId() {
    const client_id = localStorage.getItem('clientId')
    return this._http.get(this.reportUrl + '/all/' + client_id, this.buildHeaders());
  }

  resend(id: any, payload: any) {
    return this._http.post(this.reportUrl + '/resend', payload, this.buildHeaders());
  }

  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token'),
      'Content-type': 'application/json'});
    return new RequestOptions({ headers: headers });
  }
}
